module.exports = __webpack_public_path__ + "img/solar_play-broken.0aae7a3d.svg";